module.exports = __webpack_public_path__ + "static/media/quran.e19d751e.svg";